module.exports = __webpack_public_path__ + "img/checkboxEle.c264422a.svg";